import React from 'react';
import * as styles from './styles.scss';

const ButtonLoadMore = ({ className, children, ...props }) => (
    <button
        className={`${styles.lm}${className ? ` ${className}` : ''}`}
        { ...props }
    >
        {children}
    </button>
);

export default ButtonLoadMore;
